import * as React from 'react';
import { IOutput, IOutputValue, IProperty, ILoopConfigSummaryColumn, IMoveHandler } from '../../helpers';
import { Button, ButtonType, Dropdown, IDropdownOption, TextField } from 'office-ui-fabric-react';
import { Properties } from '../';

interface IProps {
    localLoopOutputOptions: IDropdownOption[];
    loopSummaryProperties: IProperty[];
    summaryColumns: ILoopConfigSummaryColumn[];
    overIndex: number;
    moveHandler: IMoveHandler;
    componentId: string;
    outputOptions: IDropdownOption[];
    updateSummaryColumns: (summaryColumns: ILoopConfigSummaryColumn[]) => void;
    updateSummaryProperty: (Name: string, Value: any) => void;
}

export class LoopSummary extends React.Component<IProps, any> {

    removeSummaryColumn = (index: number) => {

        let { summaryColumns, updateSummaryColumns } = this.props;

        summaryColumns.splice(index, 1);

        updateSummaryColumns(summaryColumns);

    }

    getSummaryColumnRows = (summaryColumn: ILoopConfigSummaryColumn, i: number): JSX.Element => {
        
        let { overIndex, moveHandler, localLoopOutputOptions } = this.props;
        
        return (
            <div key={ 'summary-column-' + i }
                className={ "option global-output loop-output clearfix " + (overIndex === i ? 'drag-over' : '') }
                onDrop={ (e) => moveHandler.drop(e, i) }
                onDragOver={ (e) => moveHandler.allowDrop(e, i) }>

                <Button buttonType={ ButtonType.icon } icon="Move"
                    title="Move column"
                    className="option-move"
                    draggable={ true }
                    onDragStart={ (e) => moveHandler.drag(e, i) }
                    onDragEnd={ (e) => moveHandler.drop(e, null) }
                    tabIndex={-1} 
                />

                <TextField className='column-name' label="Column Heading" value={ summaryColumn.columnName }
                    onChanged={ (val) => {
                        summaryColumn.columnName = val;
                        this.updateSummaryColumn(i, summaryColumn);        
                    }}  
                />

                <div className='column-output'>
                    <Dropdown options={localLoopOutputOptions} label={'Output'} selectedKey={ summaryColumn.outputId } 
                        onChanged={ (val) => {
                            summaryColumn.outputId = val.key.toString();
                            this.updateSummaryColumn(i, summaryColumn); 
                        }}
                    />
                </div>

                <Button buttonType={ ButtonType.icon } icon="Delete" onClick={ () => this.removeSummaryColumn(i) } title="Delete output"/>

            </div>
        );
    }

    updateSummaryColumn = (index: number, summaryColumn: ILoopConfigSummaryColumn) => {

        let { summaryColumns, updateSummaryColumns } = this.props;

        summaryColumns[index] = summaryColumn;

        updateSummaryColumns(summaryColumns);

    }

    addSummaryColumn = () => {
        
        let { summaryColumns, updateSummaryColumns } = this.props;

        summaryColumns.push({
            columnName: '',
            outputId: ''
        });

        updateSummaryColumns(summaryColumns);
    }

    render() {

        let { outputOptions,localLoopOutputOptions, componentId, loopSummaryProperties, updateSummaryProperty } = this.props;
        let combinedOutputOptionsProps = outputOptions.concat(localLoopOutputOptions);
        return <div className="loop-summary-wrapper">

            <div className="loop-summary-columns">

                <div className="summary-grid-heading">
                    <label className="ms-Label">Summary Grid Columns</label>
                </div>

                <Button icon="Add" onClick={ () => this.addSummaryColumn() } buttonType={ ButtonType.normal } label="Add summary column"/>
                {this.props.summaryColumns.map(this.getSummaryColumnRows)}
            </div>

            <Properties 
                primaryOnly={ false } 
                change={ (Name: string, Value: any, componentId: string) => {
                    updateSummaryProperty(Name, Value);
                } } 
                componentId={ componentId }
                properties={ loopSummaryProperties } 
                outputOptions={ combinedOutputOptionsProps }
            />
            
        </div>;
    }


}


// WEBPACK FOOTER //
// ./source/ts/components/loop/loop-summary.tsx